<div
    *ngFor="let slider of sliders; index as index; first as isFirst; last as isLast"
    emma-label
    [label]="slider.label"
    [removeOnEmpty]="true"
    i18n-label
>
    <div
        [ngClass]="{
            'input-group': true,
            'm--margin-top-15': !(hideLimitLabels || (!isFirst && firstLimitLabelsOnly))
        }"
    >
        <div class="input-group-slider">
            <ngx-slider
                *ngIf="isFirst"
                [ngClass]="'emma-ngx-slider-' + slider.color"
                [value]="sliderValues[index]"
                (valueChange)="onChangeValue(index, $event)"
                [options]="{
                    floor: min,
                    ceil: max,
                    step: step,
                    showTicksValues: showTicksValues,
                    showTicks: showTicks,
                    showSelectionBar: true,
                    draggableRange: false,
                    hidePointerLabels: true,
                    hideLimitLabels: hideLimitLabels,
                    disabled: disabled || readonly
                }"
            ></ngx-slider>
            <ng-container *ngIf="!isFirst">
                <ngx-slider
                    *ngIf="!isLast"
                    [ngClass]="'emma-ngx-slider-' + slider.color"
                    [value]="sliderValues[index - 1]"
                    (valueChange)="onChangePrevValue(index, $event)"
                    [highValue]="sliderValues[index]"
                    (highValueChange)="onChangeValue(index, $event)"
                    [options]="{
                        floor: min,
                        ceil: max,
                        step: step,
                        showTicksValues: showTicksValues,
                        showTicks: showTicks,
                        showSelectionBar: true,
                        draggableRange: false,
                        hidePointerLabels: true,
                        hideLimitLabels: hideLimitLabels || firstLimitLabelsOnly,
                        disabled: disabled || readonly
                    }"
                ></ngx-slider>
                <ngx-slider
                    *ngIf="isLast"
                    [ngClass]="'emma-ngx-slider-' + slider.color"
                    [value]="sliderValues[index - 1]"
                    (valueChange)="onChangePrevValue(index, $event)"
                    [options]="{
                        floor: min,
                        ceil: max,
                        step: step,
                        showTicksValues: showTicksValues,
                        showSelectionBarEnd: true,
                        showTicks: showTicks,
                        showSelectionBar: false,
                        draggableRange: false,
                        hidePointerLabels: true,
                        hideLimitLabels: hideLimitLabels || firstLimitLabelsOnly,
                        disabled: disabled || readonly
                    }"
                ></ngx-slider>
            </ng-container>
        </div>
        <div class="testABVersionPercent">
            <label>
                <strong>{{ slider.value }}{{ unit }}</strong>
            </label>
        </div>
    </div>
</div>
